import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {OfferEntryDataService} from '../../../core/services/offer-entry-data.service';

import {OfferEntryData} from '../../../core/models/offerEntryData';
import {Equipment} from '../../models/equipment';
import {AlertService} from '../../../core/services/alert.service';

@Component({
    selector: 'app-add-registration',
    templateUrl: './add-registration.component.html',
    styleUrls: ['./add-registration.component.css']
})
export class AddRegistrationComponent implements OnInit {
    metadata: any;

    portfolioId: string;
    startDateTime: string;
    endDateTime: string;
    product: string;
    isGroup: boolean;

    registrations: Equipment[] = [];
    new_registrations: any[] = [];

    offerEntryData: OfferEntryData;

    pagingOption: any[];
    cols: any[];

    pagination: number = 10;

    addButtonClicked: boolean = false;

    @Input() data: any;
    @Output() buttonEvent = new EventEmitter<any>();

    constructor(
        private translate: TranslateService,
        private offerEntryDataService: OfferEntryDataService,
        private alertService: AlertService
    ) {
        this.metadata = (offerEntryDataService.metadata) ? offerEntryDataService.metadata : [];
    }

    ngOnInit() {
        this.pagingOption = [
            {label: '10', value: 10},
            {label: '25', value: 25},
            {label: '50', value: 50},
            {label: '100', value: 100}
        ];

        this.cols = [
            { field: 'displayedName', header: 'Registration'}
        ];

        if (this.data) {
            if (this.data.portfolioId) {
                this.portfolioId = this.data.portfolioId;
            }
            if (this.data.startDatetime) {
                this.startDateTime = this.data.startDatetime;
            }
            if (this.data.endDatetime) {
                this.endDateTime = this.data.endDatetime;
            }
            this.isGroup = this.data.isGroup;
            this.product = this.data.product;
            this.registrations = this.data.data;
        }
    }

    addClicked() {
        if (this.new_registrations.length > 0) {
            if (!this.isGroup) {
                this.buttonEvent.emit({
                    portfolioId: this.portfolioId,
                    isGroup: this.isGroup,
                    equipmentList: this.new_registrations,
                    startDateTime: this.startDateTime,
                    endDateTime: this.endDateTime,
                    product: this.product
                });
            } else {
                this.buttonEvent.emit({
                    portfolioId: this.portfolioId,
                    isGroup: this.isGroup
                });
            }
        } else {
            this.alertService.error(this.translate.instant('shared.add-registration.nothing-selected'));
        }
    }

    cancelClicked() {
        this.buttonEvent.emit('Cancel');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/add-registration/add-registration.component.ts